import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Contact } from '../models/contacto.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface ContactoDrawerOptions {
  contactoId?: number;
  companyId?: number;
  companyName?: string;
}

@Injectable({ providedIn: 'root' })
export class ContactoDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: ContactoDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly contactoSaved$$ = new Subject<Contact>();

  readonly state = this.state$.asObservable();
  readonly contactoSaved$ = this.contactoSaved$$.asObservable();

  open(options: ContactoDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(contacto: Contact): void {
    this.contactoSaved$$.next(contacto);
  }
}
